<template>
  <div style="margin: -14px">
    <email-list
      v-if="currentEmail.id === null"
      :emails="emails"
      :current-email="currentEmail"
      @updateCurrentEmail="setCurrentEmail"
    />

    <new-email
      v-else-if="currentEmail.id === 'new'"
      :key="currentEmail.id"
      :contact="contact"
      :record="record"
      :default-data="defaultData"
      :available-records="availableRecords"
      v-on:back="backToList"
    />

    <current-email
      v-else
      :email="currentEmail"
      v-on:reply="reply"
      v-on:replyAll="replyAll"
      v-on:forward="forward"
      v-on:back="backToList"
    />
  </div>
</template>

<script>
import NewEmail from "./components/NewEmail"
import CurrentEmail from "./components/CurrentEmail"
import EmailList from "./components/EmailList"
import {CommEmailModalMixin} from "./mixins/CommEmailModal.mixin"
import {ENUMS} from "../../services/enums";
import dates from "../../services/dates";

export default {
  name: "CommEmailModalMobile",
  components: {EmailList, CurrentEmail, NewEmail},
  props: {
    contact: {
      type: Object,
      required: true
    },
    comms: {
      type: Array,
      required: true,
    },
    record: Object,
    availableRecords: {
      type: Array,
    }
  },
  data() {
    return {
      currentEmail: {id: null},
      defaultData: {}
    }
  },
  created() {
    this.currentEmail = {id: null};
    this.defaultData = null;
  },
  computed: {
    emails() {
      const emails = this.comms.filter(comm => comm.type === ENUMS.CommunicationTypeEnum.Email.value);
      return emails.sort((a, b) => new Date(b.scheduled_at) - new Date(a.scheduled_at));
    },
  },
  methods: {
    setCurrentEmail(email) {
      if (email) {
        this.currentEmail = email;
      } else {
        this.resetCurrentEmail();
      }
    },
    backToList() {
      this.currentEmail = {id: null}
      this.defaultData = null;
    },
    reply(email) {
      this.resetCurrentEmail();
      this.setDefaultData(email, 'reply');
    },
    replyAll(email) {
      this.resetCurrentEmail();
      this.setDefaultData(email, 'replyAll');
    },
    forward(email) {
      this.resetCurrentEmail();
      this.setDefaultData(email, 'forward');
    },
    resetCurrentEmail() {
      this.currentEmail = {
        id: 'new'
      }
      this.defaultData = null;
    },
    setDefaultData(email, type) {
      // available types = reply, replyAll, or forward (although forward isn't really used)
      // All types require name, date, to, subject, and body
      // ReplyAll requires cc and bcc as well
      const date = dates.formatAsDateTime(email.created_at);
      const prefix = type === 'reply' || 'replyAll' ? 'RE: ' : 'FW: ';

      let tos = [];
      let ccs = [];
      let bccs = [];

      if (type !== 'forward') {
        if (ENUMS.CommunicationDirectionEnum.Inbound.value === email.communication_direction) {
          tos = [email.email_from.email_address]
        } else {
          tos = email.email_to.map(to => to.email_address);
        }

        ccs = email.email_cc.map(cc => cc.email_address);
        bccs = email.email_bcc.map(bcc => bcc.email_address);
      }

      this.defaultData = {
        user_id: this.$store.getters.authUser.id,
        record_id: email.record_id,
        name: email.email_from.name,
        from: email.email_from.email_address,
        to: tos,
        cc: ccs,
        bcc: bccs,
        subject: prefix + email.email_subject,
        body: email.email_body,
        date: date
      }
    },
  }
}
</script>
